export { ReactComponent as OpenDiscussion } from './svgs/open-discussion.svg';
